import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/common/SEO';
import { services } from '../../data/services';
import './NotFound.css';

const NotFound = () => {
  const quickLinks = [
    { name: 'Home', path: '/', description: 'Return to our homepage' },
    { name: 'About Kirstie', path: '/about', description: 'Meet your holistic health practitioner' },
    { name: 'Events & Workshops', path: '/events', description: 'Upcoming meditation circles & workshops' },
    { name: 'Courses & Training', path: '/courses', description: 'Reiki certification & training programs' },
    { name: 'Book a Session', path: '/booking', description: 'Schedule your healing session' },
    { name: 'Gallery', path: '/gallery', description: 'Explore our healing spaces' },
    { name: 'Speaker & Facilitator', path: '/speaker', description: 'Invite Kirstie to your event' },
    { name: 'Contact Us', path: '/contact', description: 'Get in touch with us' },
  ];

  return (
    <>
      <SEO
        title="Page Not Found | KO Holistic Health"
        description="The page you're looking for doesn't exist. Explore our new 2026 website for Reiki healing, tarot readings, soul coaching and holistic health services in Sydney."
        noindex={true}
      />

      <div className="not-found-page">
        <section className="not-found-hero">
          <div className="container">
            <div className="not-found-hero__content">
              <span className="not-found-hero__code">404</span>
              <h1>Oops! This page doesn't exist</h1>
              <p className="not-found-hero__message">
                It looks like you've followed an old link or typed something that doesn't match our pages.
                We've recently launched our <strong>brand new 2026 website</strong> with a fresh design and updated links,
                so some old URLs may no longer work.
              </p>
              <Link to="/" className="not-found-hero__home-btn">
                Go to Homepage
              </Link>
            </div>
          </div>
        </section>

        <section className="not-found-directory">
          <div className="container">
            <h2>Explore Our Website</h2>
            <p className="not-found-directory__intro">
              Here's a complete directory of our new site to help you find what you're looking for:
            </p>

            <div className="not-found-directory__grid">
              <div className="not-found-directory__section">
                <h3>Pages</h3>
                <ul className="not-found-directory__links">
                  {quickLinks.map((link) => (
                    <li key={link.path}>
                      <Link to={link.path}>
                        <span className="not-found-directory__link-name">{link.name}</span>
                        <span className="not-found-directory__link-desc">{link.description}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="not-found-directory__section">
                <h3>Our Services</h3>
                <ul className="not-found-directory__links">
                  {services.map((service) => (
                    <li key={service.slug}>
                      <Link to={`/services/${service.slug}`}>
                        <span className="not-found-directory__link-name">{service.name}</span>
                        <span className="not-found-directory__link-desc">{service.tagline}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="not-found-directory__cta">
              <p>Can't find what you need?</p>
              <Link to="/contact" className="not-found-directory__contact-btn">
                Contact Us
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default NotFound;
